import RequestCallButton from './RequestCallButton';
import { colors } from '../../styles/theme';

/**
 * A refusal of new business that sends the client to their Account Executive
 * (`lib/executiveRefusal.ts`): the server's sentence, then the call action right there,
 * so the client is never left thinking there is nothing they can do (owner, 2026-10-30).
 * Not styled as an error: nothing went wrong on their side.
 */
export default function ExecutiveRefusal({
  message,
  productId,
  context,
}: Readonly<{
  message: string;
  productId?: string | null;
  context: string;
}>): JSX.Element {
  return (
    <section
      role="status"
      aria-live="polite"
      className="rounded-xl p-4 mb-4"
      style={{ background: colors.warningBg, border: '1px solid #FCD34D', color: colors.ink }}
    >
      <p className="text-sm">{message}</p>
      <RequestCallButton productId={productId} context={context} />
    </section>
  );
}
